import React, {FC} from 'react';
import dayjs from 'dayjs';
import {IDealerInfo} from 'store/models/dealers';
import styles from '../DealersInformation.module.scss';

interface Props {
  dealerData: IDealerInfo | undefined;
}

const ActivityLogTab: FC<Props> = (props) => {
  return (
    <div className={styles.dealersActivityLogTab}>
      {props?.dealerData?.audit?.creating ? (
        <div>
          <span className={styles.auditTitle}>Created at</span>
          <span className={styles.auditText}>
            {dayjs(props?.dealerData?.audit.creating?.actionDateTime).format(
              'DD.MM.YYYY HH:mm:ss',
            ) || null}
          </span>
          <span className={styles.auditText}>
            {props?.dealerData?.audit.creating?.userEmail}
          </span>
          <span className={styles.auditText}>
            {props?.dealerData?.audit.creating?.userFullName}
          </span>
        </div>
      ) : null}

      {props?.dealerData?.audit?.updating ? (
        <div>
          <span className={styles.auditTitle}>Updated at</span>
          <span className={styles.auditText}>
            {dayjs(props?.dealerData?.audit.updating?.actionDateTime).format(
              'DD.MM.YYYY HH:mm:ss',
            ) || null}
          </span>
          <span className={styles.auditText}>
            {props?.dealerData?.audit.updating?.userEmail}
          </span>
          <span className={styles.auditText}>
            {props?.dealerData?.audit.updating?.userFullName}
          </span>
        </div>
      ) : null}

      {props?.dealerData?.audit?.deleting ? (
        <div>
          <span className={styles.auditTitle}>Deleted at</span>
          <span className={styles.auditText}>
            {dayjs(props?.dealerData?.audit.deleting?.actionDateTime).format(
              'DD.MM.YYYY HH:mm:ss',
            ) || null}
          </span>
          <span className={styles.auditUpdatedText}>
            {props?.dealerData?.audit.deleting?.userEmail}
          </span>
          <span className={styles.auditUpdatedText}>
            {props?.dealerData?.audit.deleting?.userFullName}
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default ActivityLogTab;
